<template>
	<div class="center_branch_box">
		<!-- 标题 -->
		<center-title>{{$t("message.cbranch.title")}}</center-title>
		<!-- 表格 -->
		<branch-table v-model="search" :prop-attr="sortAttr" :order="sortMode" :current-page="page.current_page"
			:page-count="page.last_page" @handleSearch="handleSearch" @selection-change="handleSelectionChange"
			@handleSort="handleSort" @current-change="handleCurrent" @handleModify="getDetail" @handleDelete="handleDel"
			@batch-del="handleBatchDel">
		</branch-table>
		<!-- 模态框 -->
		<branch-dialog @handleModify="handleModify" @handleClose="handleCloseDialog">
			<template #form>
				<branch-form ref="editForm" :key="editForm" :branch-detail="branch_detail">
				</branch-form>
			</template>
		</branch-dialog>
		<!-- 添加 -->
		<branch-add>
			<template #addForm>
				<branch-form :key="addForm">
					<template #submit="{ form, rule }">
						<el-button type="primary" @click="handleSubmit(form, rule)">
							<span>{{$t("public.submitBtn")}}</span>
						</el-button>
					</template>
				</branch-form>
			</template>
		</branch-add>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions,
		mapMutations
	} from "vuex";
	import {
		tableRouterView
	} from "@/utils/publicMethod.js";

	export default {
		mixins: [tableRouterView],
		computed: mapState({
			power: state => state.user.power,
			user_info: state => state.user.user_info,
			branch_detail: state => state.user.branch_detail,
			page: state => state.user.page
		}),
		components: {
			centerTitle: () => import("@/components/center/centerTitle"),
			branchTable: () => import("@/components/center/branchTable"),
			branchDialog: () => import("@/components/center/branchDialog"),
			branchAdd: () => import("@/components/center/branchAdd"),
			branchForm: () => import("@/components/center/branchForm")
		},
		methods: {
			...mapMutations([
				"setBalance",
				'setBranchList',
				'setBranchParent',
				'handleDialog',
				'setBranchDetail',
				'setPage'
			]),
			...mapActions([
				"getBranchList",
				"getBranchParent",
				"getBranchBalance",
				'handleAddBranch',
				'getBranchDetail',
				'handleDelBranch'
			]),
			// 查
			getBranchData(search, attr, mode, page = 1) {
				let branch_id = this.user_info.branch_id || 0;
				this.getBranchBalance(branch_id);
				this.getBranchList({
					search,
					attr,
					mode,
					page
				})
				this.getBranchParent();
			},
			changeRouter(search, attr, mode, page = 1) {
				this.$router.push({
					name: 'branch',
					query: {
						search,
						attr,
						mode,
						page
					}
				}).catch(err => err)
			},
			getDetail(branch_id) {
				this.getBranchDetail(branch_id);
				this.getBranchParent(branch_id);
			},
			// 删
			handleDel(res) {
				if (res.code == 1) {
					this.$message({
						showClose: true,
						message: this.$t("public.delSucc"),
						type: "success"
					})
					setTimeout(() => {
						this.getBranchData(this.search, this.sortAttr, this.sortMode, this.$route.query.page);
					}, 1000)
				} else {
					this.$message({
						showClose: true,
						message: this.$t(res.msg),
						type: "error"
					})
				}
				// if(res){
				//     this.$message({
				//         showClose: true,
				//         message: this.$t("public.delSucc"),
				//         type: "success"
				//     })
				//     setTimeout(() => {
				//         this.getBranchData(this.search, this.sortAttr, this.sortMode, this.$route.query.page);
				//     },1000)
				// }
			},
			//批量删除
			handleBatchDel() {
				this.$confirm(this.$t("message.cbranch.isDel"), {
					confirmButtonText: this.$t("public.confirmBtn"),
					cancelButtonText: this.$t("public.cancelBtn"),
					type: 'warning'
				}).then(() => {
					let list = this.selectedList.map(element => {
						return element.branch_id
					});
					if(list.length==0){
						this.$message({
							showClose: true,
							message: '請選擇刪除公司',
							type: "error"
						})
						return
					}
					let id = list.join();
					return this.handleDelBranch(id)
				}).then((res) => {
					this.handleDel(res)
				}).catch(() => {})
			},
			// 增
			handleSubmit(form, rule) {
				let r1 = rule.rule1.validate(),
					r2 = rule.rule2.validate(),
					r3 = rule.rule3.validate(),
					r4 = rule.rule4.validate(),
					r5 = rule.rule5.validate();
				Promise.all(
					[r1, r2, r3, r4, r5]
				).then(() => {
					this.handleAddBranch({
						parent_id: form.parent_id,
						parentname: form.parentname,
						branch_code: form.branch_code,
						branchname: form.cn_name,
						en_branchname: form.en_name,
						principal: form.principal,
						phone: form.phone,
						email: form.email,
						address: form.address,
						fax: form.fax,
						amount: form.amount || ''
					}).then(res => {
						// console.log(res)
						if (res.code == 1) {
							this.addForm = this.addForm == 0 ? 1 : 0;
							this.$message({
								showClose: true,
								message: this.$t("public.addSucc"),
								type: "success"
							})
							setTimeout(() => {
								this.getBranchData(this.search, this.sortAttr, this.sortMode, this
									.$route.query.page);
							}, 1000)
						} else {
							this.$message({
								showClose: true,
								message: this.$t(res.msg),
								type: "error"
							})
						}
					})
				}).catch(err => console.log('err=', err))
			},
			// 改
			handleCloseDialog() {
				this.handleDialog(false);
				this.setBranchDetail({});
				this.getBranchData(this.search, this.sortAttr, this.sortMode, this.$route.query.page);
			},
			handleModify(handleClose) {
				let form = this.$refs.editForm.form,
					rule = this.$refs.editForm.$refs;

				let r1 = rule.rule1.validate(),
					r2 = rule.rule2.validate(),
					r3 = rule.rule3.validate(),
					r4 = rule.rule4.validate(),
					r5 = rule.rule5.validate();

				Promise.all(
					[r1, r2, r3, r4, r5]
				).then(() => {
					this.handleAddBranch({
						parent_id: form.parent_id,
						parentname: form.parentname,
						branch_code: form.branch_code,
						branch_id: this.branch_detail.branch_id,
						branchname: form.cn_name,
						en_branchname: form.en_name,
						principal: form.principal,
						phone: form.phone,
						email: form.email,
						address: form.address,
						fax: form.fax,
						amount: form.amount || '',
						url: "/index/branch/editpost"
					}).then((res) => {
						console.log("測試", res)
						if (res.code == 1) {
							this.editForm = this.editForm == 0 ? 1 : 0;
							this.$message({
								showClose: true,
								message: this.$t("public.modifySucc"),
								type: "success"
							})
							setTimeout(() => {
								handleClose();
							}, 1000)
						} else {
							this.$message({
								showClose: true,
								message: res.msg,
								type: "error"
							})
						}
						//              if(res){
						//                  this.editForm = this.editForm == 0? 1: 0;
						//                  this.$message({
						//                      showClose: true,
						//                      // message: this.$t("public.modifySucc"),
						// message: res,
						//                      type: "success"
						//                  })
						//                  setTimeout(() => {
						//                      handleClose();
						//                  },1000)
						//              }else{
						//                  this.$message({
						//                      showClose: true,
						//                      message: this.$t("message.cbranch.errmsg"),
						//                      type: "error"
						//                  })
						//              }
					})
				}).catch(err => err)
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				setTimeout(() => {
					let allow = vm.power.includes(0) || vm.power.includes(1);
					let {
						search = '',
							attr = '',
							mode = '',
							page = 1
					} = to.query;
					if (!allow) {
						vm.$router.back();
						return false;
					}
					vm.getBranchData(search, attr, mode, page);	
				}, 500)
			
			})
		},
		beforeRouteUpdate(to, from, next) {
			let {
				search,
				attr,
				mode,
				page
			} = to.query;
			this.getBranchData(search, attr, mode, page);
			next();
		},
		beforeRouteLeave(to, from, next) {
			this.setBalance(0);
			this.setBranchParent([]);
			this.setBranchList([]);
			this.setPage({});
			next();
		}
	}
</script>
